import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { COMMERCIAL_RETROFIT_FAQS } from "@/components/landing/lp-commercial-retrofit";

import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpCommercialRetrofitPage = lazyNamed(
  () => import("@/components/landing/lp-commercial-retrofit"),
  "LpCommercialRetrofit",
);
import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";

const PATH = "/commercial-retrofit";
const TITLE =
  "Whole-House Retrofit & Decarbonisation | PAS 2035 | Framework-Ready | CRS Energy";
const DESCRIPTION =
  "PAS 2035 coordinated whole-house retrofit for councils, housing associations and frameworks. Fabric-first, TEP-aligned delivery with TrustMark lodgement and evidenced carbon reporting.";
const BREADCRUMB_NAME = "Whole-House Retrofit & Decarbonisation";

export const Route = createFileRoute("/commercial-retrofit")({
  head: () => ({
    ...pageSeo({
      path: PATH,
      title: TITLE,
      description: DESCRIPTION,
      ogType: "article",
    }),
    scripts: [
      serviceJsonLdScript({
        name: BREADCRUMB_NAME,
        description: DESCRIPTION,
        serviceType: "Whole-House Retrofit & Decarbonisation",
        url: `${SITE.url}${PATH}`,
      }),
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: COMMERCIAL_RETROFIT_FAQS.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
      breadcrumbJsonLdScript(commercialBreadcrumbTrail(BREADCRUMB_NAME, PATH)),
    ],
  }),
  component: LpCommercialRetrofitPage,
});
